// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-limit[data-v-449428d4]{\n    resize: none;\n    max-height: 150px;\n}\n", ""]);
// Exports
module.exports = exports;
